import React from 'react';
import utils from '../utils';

type Props = {
  resource: string,
}

const Video: React.FunctionComponent<Props> = ({ resource }) => (
  <iframe
    style={{
      border: "1px solid #CCC",
      borderWidth: 1,
      marginBottom: 5,
      maxWidth: "100%"
    }}
    src={utils.videoPath(resource)}
    width="500"
    height="360"
    frameBorder="0"
    allowFullScreen={true}
    title="Video"
  />
);

export default Video;
